import { Row, Col, Container } from "react-bootstrap";

const Demosystem = () => {
  return (
    <Container fluid>
      <Row className="opacity-bg lp-demo-bar">
        <Col className="lp-demo-content">
          <div>
            <h2 className="lp-demo-heading">Not convinced yet?</h2>
            <p className="lp-demo-subtext">
              Try our free Demo — pre-filled with test data, resets every hour.
            </p>
          </div>
          <a
            href="https://demo.freelancersplace.net"
            target="_blank"
            rel="noreferrer"
            className="btn btn-light lp-demo-btn"
          >
            Open Demo →
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default Demosystem;
